import { render, staticRenderFns } from "./AdminHospitals.vue?vue&type=template&id=0463f87d"
import script from "./AdminHospitals.vue?vue&type=script&lang=js"
export * from "./AdminHospitals.vue?vue&type=script&lang=js"
import style0 from "./AdminHospitals.vue?vue&type=style&index=0&id=0463f87d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports